import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { SurveyResponseLayoutProps } from '../types';
import { LanguageToggle } from './LanguageToggle';
import { ProgressIndicator } from './ProgressIndicator';
import '../styles/survey-response.css';

export const SurveyResponseLayout: React.FC<SurveyResponseLayoutProps> = ({
  children,
  language,
  onLanguageChange,
  showProgress = false,
  currentStep = 0,
  totalSteps = 0,
}) => {
  return (
    <Box
      className="survey-response-page survey-response-container"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto', // Enable scrolling on the main container
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'sticky', // Make header sticky
          top: 0,
          zIndex: 1000,
          backgroundColor: 'background.paper',
          borderBottom: 1,
          borderColor: 'divider',
          height: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
        }}
      >
        <Typography variant="h6">Lecturo</Typography>
        <LanguageToggle currentLanguage={language} onLanguageChange={onLanguageChange} />
      </Box>

      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          py: 3,
          minHeight: 'calc(100vh - 48px)', // Ensure minimum height accounting for header
        }}
      >
        {showProgress && totalSteps > 1 && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <ProgressIndicator
              currentIndex={currentStep}
              totalQuestions={totalSteps}
              completedQuestions={Array.from({ length: currentStep }, (_, i) => i)}
            />
          </Box>
        )}

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: '16px 0', // Add some padding for better mobile experience
          }}
        >
          {children}
        </Box>
      </Container>
    </Box>
  );
};
